/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Description_PlaceholderInputs */

const en_case_field_description_placeholder = /** @type {(inputs: Case_Field_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe what happened in detail…`)
};

const pt_br2_case_field_description_placeholder = /** @type {(inputs: Case_Field_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descreva o ocorrido com detalhes…`)
};

/**
* | output |
* | --- |
* | "Describe what happened in detail…" |
*
* @param {Case_Field_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_description_placeholder = /** @type {((inputs?: Case_Field_Description_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Description_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_description_placeholder(inputs)
	return pt_br2_case_field_description_placeholder(inputs)
});